import { h } from 'preact';
import { IconHeart } from '../../../ui/icons';

type Props = {
  level: number; // 0 to 100
  levelName?: string;
  className?: string;
};

export function RelationshipBar({ level, levelName, className }: Props) {
  // Horizontal layout: Heart -> Bar -> Percent
  return (
    <div class={`relationship-bar-container ${className || ''}`}>
      {/* Size controlled via CSS .rel-heart-icon */}
      <IconHeart filled={level > 0} class="rel-heart-icon" />
      
      <div class="rel-track">
        <div 
          class="rel-fill-glow" 
          style={{ width: `${level}%` }}
        />
        <div 
          class="rel-fill" 
          style={{ width: `${level}%` }}
        />
      </div>

      <span class="rel-percent">{Math.round(level)}%</span>
    </div>
  );
}
